var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEdit = function SvgEdit(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99999 16H17H8.99999Z",
    fill: "#5547DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.5329C1 14.1044 1 13.8901 1.04912 13.6884C1.09267 13.5096 1.1645 13.3387 1.26197 13.182C1.37192 13.0051 1.52565 12.8536 1.83312 12.5506L13 1.54434C13.7364 0.818554 14.9303 0.818554 15.6667 1.54434C16.4031 2.27012 16.4031 3.44685 15.6667 4.17264L4.49981 15.1789C4.19234 15.4819 4.03861 15.6334 3.8592 15.7418C3.70014 15.8379 3.52673 15.9087 3.34533 15.9516C3.14073 16 2.92331 16 2.48848 16H1V14.5329Z",
    fill: "#5547DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99999 16H17M1 16H2.48848C2.92331 16 3.14073 16 3.34533 15.9516C3.52673 15.9087 3.70014 15.8379 3.8592 15.7418C4.03861 15.6334 4.19234 15.4819 4.49981 15.1789L15.6667 4.17264C16.4031 3.44685 16.4031 2.27012 15.6667 1.54434C14.9303 0.818554 13.7364 0.818554 13 1.54434L1.83312 12.5506C1.52565 12.8536 1.37192 13.0051 1.26197 13.182C1.1645 13.3387 1.09267 13.5096 1.04912 13.6884C1 13.8901 1 14.1044 1 14.5329V16Z",
    stroke: "#5547DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "edit.fd0d9e517ab4f3c03b9fc19c910a4ef4.svg";